export default __webpack_public_path__ + "static/media/tmonial2.57c24b7d.jpg";